module.exports = __webpack_public_path__ + "img/ysc.69f34ac0.png";